import { setSelectedParcours } from "../reducers/parcours"
import { setSelectedTutoriel } from "../reducers/tutoriels"
import { store } from "../store/store"
import axios from "axios"

const { RECOMMENDATION_API_ROUTE } = require("../../routes/api/api_routes")


const tutoriels = {
    getTutoriel(user_id){
        return new Promise((resolve,reject)=>{
            axios.post(`${RECOMMENDATION_API_ROUTE}${user_id}`)
            .then(response => {
                if(response.status === 200){
                    let tuto = response.data
                    let dispatch = store.dispatch
                    dispatch(setSelectedTutoriel(tuto))
                    resolve(tuto)
                }else{
                    reject(response)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err)
            })
        })
    },
}
export default tutoriels